import {barrel as barrelConfig} from 'cfg/slot-config';
import {Barrel as Barrel} from 'barrel';

import {MainScene} from './mainscene';

import {doublegame as doubleGameConfig} from 'cfg/doublegame-config';
import {DoubleGameScene} from 'novomat_redblack_gamble';
//import {DerivedDoubleGameScene} from 'derived-gamble';

import helpConfig from 'cfg/help-config';
// import {HelpScene} from 'helpscene';
import {DerivedHelpScene} from 'derived-help';

import {SlotMath as GameMath} from 'slot-math';

export default function construct(spec) {
    
    const mathSpec = {
        lines: spec.specification.linesCountMax,
        symbols: spec.specification.symbolsCount,
        wild: spec.specification.symbolWild,
        scatter: spec.specification.symbolScatter,
        
        trajectories: spec.specification.linesPaths,
        price: spec.specification.priceList,
        scatterPrice: spec.specification.scatterWinCoeffs,
        substitutableElements: spec.specification.substitutableElements,
        wildLineWinMultiplier: spec.specification.wildLineWinMultiplier,
        freegamesMultiplier: spec.specification.freeSpinWinMultiplier,
        winShapes: spec.specification.winShapes
    };

    
    // спрятать создание сразу в слотовую сцену - это больше нигде не нужно
    // слотовой сцене передавать спеку от сервера
    const math = new GameMath(mathSpec);
    
    const barrel = new Barrel(barrelConfig, barrelConfig.symbolsCount, mathSpec.scatter);
    
    const slotScene = new MainScene(spec, math);
    slotScene.setBarrel(barrel);
    
    // в спеке может быть несколько спецификаций рисков
    for (var i = 0; i < spec.risks.length; i++) {
        // предположим что это нужная нам спецификация
        if (spec.risks[i].specification.riskId === 1) {
            doubleGameConfig.suits = spec.risks[i].specification.suitNames;
        }
    }
    
    const doubleGameScene = new DoubleGameScene(doubleGameConfig);
    //const doubleGameScene = new DerivedDoubleGameScene(doubleGameConfig);

    // const helpScene = new HelpScene(null/*controller*/, null/*model*/, math, helpConfig.help);
    const helpScene = new DerivedHelpScene(null/*controller*/, null/*model*/, math, helpConfig.help);

    return {
        barrel,
        slotScene: {
            view:slotScene,
            z:0
        },
        doubleGameScene: {
            view:doubleGameScene,
            z:1
        },
        helpScene: {
            view:helpScene,
            z:2
        }
    }
}



// WEBPACK FOOTER //
// ./src/construct.es6